<div class="row">

  <div class="col-md-12">
  
    
      <app-list-university-education></app-list-university-education>




  </div>

  <div class="col-md-12">
  
    
     <app-list-senior-high-education></app-list-senior-high-education>



  </div>
  <div class="col-md-12">
  
    
      <app-list-certificate></app-list-certificate>




  </div>
  <div class="col-md-12">
  
      <app-list-research-experience></app-list-research-experience>



  </div>
  <div class="col-md-12">
  
<app-list-work-experience></app-list-work-experience>
  </div>
  <div class="clearfix"></div>
</div>